import { render } from "./tw-panel.vue?vue&type=template&id=471ae89a"
import script from "./tw-panel.vue?vue&type=script&lang=js"
export * from "./tw-panel.vue?vue&type=script&lang=js"
script.render = render

export default script